import type { Adventure } from '../../types'

// Age 4-5: Pattern Detective
export const patternFunAdventure: Adventure = {
  id: 'pattern-fun',
  title: 'Pattern Detective',
  theme: 'patterns',
  targetAge: '4',
  difficulty: 'easy',
  estimatedDuration: 6,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hello, pattern detective! Patterns are when things repeat in order. Like red, blue, red, blue! Can you find what comes next?",
      duration: 6
    },
    story1: {
      id: 'story-1',
      tillyLine: "Look at this pattern: 2, 4, 6... What's next? These numbers are getting bigger by 2 each time!",
      duration: 6,
      background: 'pattern-world'
    },
    choice1: [
      {
        id: 'continue-pattern',
        label: 'Continue it!',
        tillyLine: "What number comes after 6 in this pattern?",
        nextState: 'quiz-1'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'pattern-complete',
      question: '2, 4, 6, ___',
      tillyPrompt: 'What comes next?',
      options: [
        { id: '6', label: '6', isCorrect: false },
        { id: '7', label: '7', isCorrect: false },
        { id: '8', label: '8', isCorrect: true }
      ],
      pattern: [2, 4, 6, '___'],
      correctAnswer: 8
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Brilliant! The answer was 8! Now let's try a counting pattern: 1, 2, 3, 4... What comes next?",
      duration: 5,
      background: 'pattern-world'
    },
    choice2: [
      {
        id: 'count-pattern',
        label: 'Count on!',
        tillyLine: "What number comes after 4?",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'pattern-complete',
      question: '1, 2, 3, 4, ___',
      tillyPrompt: 'What number is next?',
      options: [
        { id: '4', label: '4', isCorrect: false },
        { id: '5', label: '5', isCorrect: true },
        { id: '6', label: '6', isCorrect: false }
      ],
      pattern: [1, 2, 3, 4, '___'],
      correctAnswer: 5
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "You're a pattern expert! Here's the big one: 5, 10, 15... what comes next?",
        duration: 5,
        background: 'pattern-world'
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'pattern-complete',
          question: '5, 10, 15, ___',
          tillyPrompt: 'What number is missing?',
          options: [
            { id: '16', label: '16', isCorrect: false },
            { id: '20', label: '20', isCorrect: true },
            { id: '25', label: '25', isCorrect: false }
          ],
          pattern: [5, 10, 15, '___'],
          correctAnswer: 20
        } as any
      ]
    },
    reward: {
      tillyLine: "Incredible! You found all the patterns! You're a true Pattern Detective! Here's your badge!",
      badgeName: 'Pattern Detective',
      badgeIcon: '🧩',
      nextPreview: 'Next time, we\'ll count even higher!'
    }
  }
}
